import styled from "styled-components";

export const NotFoundContainer = styled.div`
  background-color: red;
`;
